// third-party
import { combineReducers } from 'redux';

// project imports
import guidedToolReducer from './slices/guideTool';
import eventFormReducer from './slices/eventForm';
import accountReducer from './slices/account';
import appFormReducer from './slices/application.slice';
import dashboardReducer from './slices/dashboard';
import announcementReducer from './slices/announcement.slice';
import eAdvisorReducer from './slices/eadvisor.slice';
import notificationReducer from './slices/notification';
import { paymentApi } from './api/payment.api';
import postalReducer from './slices/postal.slice';
import newspaperRegisterReducer from './slices/newspaperRegister.slice';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
    [paymentApi.reducerPath]: paymentApi.reducer,
    guidedTool: guidedToolReducer,
    eventForm: eventFormReducer,
    account: accountReducer,
    appForm: appFormReducer,
    dashboard: dashboardReducer,
    announcement: announcementReducer,
    notification: notificationReducer,
    eAdvisor: eAdvisorReducer,
    postal: postalReducer,
    newspaperRegister: newspaperRegisterReducer
});

export default reducer;
